// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file status/v1/status.proto (package status.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Status, StatusJson } from "../../google/rpc/status_pb";
import { file_google_rpc_status } from "../../google/rpc/status_pb";
import type { Notification, NotificationJson } from "../../notifications/v2/notifications_pb";
import { file_notifications_v2_notifications } from "../../notifications/v2/notifications_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file status/v1/status.proto.
 */
export const file_status_v1_status: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_events, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_rpc_status, file_notifications_v2_notifications],
	);

/**
 * @generated from message status.v1.StartWorkflowRunEvent
 */
export type StartWorkflowRunEvent = Message<"status.v1.StartWorkflowRunEvent"> & {
	/**
	 * @generated from field: status.v1.Run run = 1;
	 */
	run?: Run;
};

/**
 * @generated from message status.v1.StartWorkflowRunEvent
 */
export type StartWorkflowRunEventJson = {
	/**
	 * @generated from field: status.v1.Run run = 1;
	 */
	run?: RunJson;
};

/**
 * Describes the message status.v1.StartWorkflowRunEvent.
 * Use `create(StartWorkflowRunEventSchema)` to create a new message.
 */
export const StartWorkflowRunEventSchema: GenMessage<StartWorkflowRunEvent, { jsonType: StartWorkflowRunEventJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 0);

/**
 * @generated from message status.v1.CompleteWorkflowRunEvent
 */
export type CompleteWorkflowRunEvent = Message<"status.v1.CompleteWorkflowRunEvent"> & {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId: string;
};

/**
 * @generated from message status.v1.CompleteWorkflowRunEvent
 */
export type CompleteWorkflowRunEventJson = {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId?: string;
};

/**
 * Describes the message status.v1.CompleteWorkflowRunEvent.
 * Use `create(CompleteWorkflowRunEventSchema)` to create a new message.
 */
export const CompleteWorkflowRunEventSchema: GenMessage<CompleteWorkflowRunEvent, { jsonType: CompleteWorkflowRunEventJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 1);

/**
 * @generated from message status.v1.ReportWorkflowStepEvent
 */
export type ReportWorkflowStepEvent = Message<"status.v1.ReportWorkflowStepEvent"> & {
	/**
	 * @generated from field: status.v1.Step step = 1;
	 */
	step?: Step;
};

/**
 * @generated from message status.v1.ReportWorkflowStepEvent
 */
export type ReportWorkflowStepEventJson = {
	/**
	 * @generated from field: status.v1.Step step = 1;
	 */
	step?: StepJson;
};

/**
 * Describes the message status.v1.ReportWorkflowStepEvent.
 * Use `create(ReportWorkflowStepEventSchema)` to create a new message.
 */
export const ReportWorkflowStepEventSchema: GenMessage<ReportWorkflowStepEvent, { jsonType: ReportWorkflowStepEventJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 2);

/**
 * @generated from message status.v1.Step
 */
export type Step = Message<"status.v1.Step"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string run_id = 2;
	 */
	runId: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: status.v1.StepStatus status = 5;
	 */
	status: StepStatus;

	/**
	 * @generated from field: google.rpc.Status error = 6;
	 */
	error?: Status;

	/**
	 * @generated from field: google.protobuf.Value metadata = 7;
	 */
	metadata?: Value;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: Timestamp;
};

/**
 * @generated from message status.v1.Step
 */
export type StepJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string run_id = 2;
	 */
	runId?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: status.v1.StepStatus status = 5;
	 */
	status?: StepStatusJson;

	/**
	 * @generated from field: google.rpc.Status error = 6;
	 */
	error?: StatusJson;

	/**
	 * @generated from field: google.protobuf.Value metadata = 7;
	 */
	metadata?: ValueJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: TimestampJson;
};

/**
 * Describes the message status.v1.Step.
 * Use `create(StepSchema)` to create a new message.
 */
export const StepSchema: GenMessage<Step, { jsonType: StepJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 3);

/**
 * @generated from message status.v1.Run
 */
export type Run = Message<"status.v1.Run"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: optional string opaque_id = 13;
	 */
	opaqueId?: string;

	/**
	 * @generated from field: string workflow_id = 2;
	 */
	workflowId: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: Creator;

	/**
	 * @generated from field: string workflow_name = 6;
	 */
	workflowName: string;

	/**
	 * @generated from field: bool completed = 7;
	 */
	completed: boolean;

	/**
	 * @generated from field: int32 success_count = 8;
	 */
	successCount: number;

	/**
	 * @generated from field: int32 error_count = 9;
	 */
	errorCount: number;

	/**
	 * @generated from field: status.v1.InputMetadata input_metadata = 10;
	 */
	inputMetadata?: InputMetadata;

	/**
	 * @generated from field: notifications.v2.Notification summary_notification = 12;
	 */
	summaryNotification?: Notification;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp;
};

/**
 * @generated from message status.v1.Run
 */
export type RunJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: optional string opaque_id = 13;
	 */
	opaqueId?: string;

	/**
	 * @generated from field: string workflow_id = 2;
	 */
	workflowId?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string workflow_name = 6;
	 */
	workflowName?: string;

	/**
	 * @generated from field: bool completed = 7;
	 */
	completed?: boolean;

	/**
	 * @generated from field: int32 success_count = 8;
	 */
	successCount?: number;

	/**
	 * @generated from field: int32 error_count = 9;
	 */
	errorCount?: number;

	/**
	 * @generated from field: status.v1.InputMetadata input_metadata = 10;
	 */
	inputMetadata?: InputMetadataJson;

	/**
	 * @generated from field: notifications.v2.Notification summary_notification = 12;
	 */
	summaryNotification?: NotificationJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;
};

/**
 * Describes the message status.v1.Run.
 * Use `create(RunSchema)` to create a new message.
 */
export const RunSchema: GenMessage<Run, { jsonType: RunJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 4);

/**
 * @generated from message status.v1.CsvMetadata
 */
export type CsvMetadata = Message<"status.v1.CsvMetadata"> & {
	/**
	 * @generated from field: repeated string header = 1;
	 */
	header: string[];
};

/**
 * @generated from message status.v1.CsvMetadata
 */
export type CsvMetadataJson = {
	/**
	 * @generated from field: repeated string header = 1;
	 */
	header?: string[];
};

/**
 * Describes the message status.v1.CsvMetadata.
 * Use `create(CsvMetadataSchema)` to create a new message.
 */
export const CsvMetadataSchema: GenMessage<CsvMetadata, { jsonType: CsvMetadataJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 5);

/**
 * @generated from message status.v1.InputMetadata
 */
export type InputMetadata = Message<"status.v1.InputMetadata"> & {
	/**
	 * @generated from oneof status.v1.InputMetadata.type
	 */
	type:
		| {
				/**
				 * @generated from field: status.v1.CsvMetadata csv = 1;
				 */
				value: CsvMetadata;
				case: "csv";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message status.v1.InputMetadata
 */
export type InputMetadataJson = {
	/**
	 * @generated from field: status.v1.CsvMetadata csv = 1;
	 */
	csv?: CsvMetadataJson;
};

/**
 * Describes the message status.v1.InputMetadata.
 * Use `create(InputMetadataSchema)` to create a new message.
 */
export const InputMetadataSchema: GenMessage<InputMetadata, { jsonType: InputMetadataJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 6);

/**
 * @generated from message status.v1.RunFilter
 */
export type RunFilter = Message<"status.v1.RunFilter"> & {
	/**
	 * @generated from field: optional string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string opaque_id = 4;
	 */
	opaqueId?: string;

	/**
	 * @generated from field: optional string workflow_id = 5;
	 */
	workflowId?: string;

	/**
	 * @generated from field: optional bool completed = 2;
	 */
	completed?: boolean;

	/**
	 * @generated from field: optional bool has_errors = 3;
	 */
	hasErrors?: boolean;
};

/**
 * @generated from message status.v1.RunFilter
 */
export type RunFilterJson = {
	/**
	 * @generated from field: optional string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string opaque_id = 4;
	 */
	opaqueId?: string;

	/**
	 * @generated from field: optional string workflow_id = 5;
	 */
	workflowId?: string;

	/**
	 * @generated from field: optional bool completed = 2;
	 */
	completed?: boolean;

	/**
	 * @generated from field: optional bool has_errors = 3;
	 */
	hasErrors?: boolean;
};

/**
 * Describes the message status.v1.RunFilter.
 * Use `create(RunFilterSchema)` to create a new message.
 */
export const RunFilterSchema: GenMessage<RunFilter, { jsonType: RunFilterJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 7);

/**
 * @generated from message status.v1.StepFilter
 */
export type StepFilter = Message<"status.v1.StepFilter"> & {
	/**
	 * @generated from field: repeated status.v1.StepStatus statuses = 1;
	 */
	statuses: StepStatus[];
};

/**
 * @generated from message status.v1.StepFilter
 */
export type StepFilterJson = {
	/**
	 * @generated from field: repeated status.v1.StepStatus statuses = 1;
	 */
	statuses?: StepStatusJson[];
};

/**
 * Describes the message status.v1.StepFilter.
 * Use `create(StepFilterSchema)` to create a new message.
 */
export const StepFilterSchema: GenMessage<StepFilter, { jsonType: StepFilterJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 8);

/**
 * @generated from message status.v1.ListWorkflowRunsRequest
 */
export type ListWorkflowRunsRequest = Message<"status.v1.ListWorkflowRunsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: status.v1.RunFilter filter = 3;
	 */
	filter?: RunFilter;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message status.v1.ListWorkflowRunsRequest
 */
export type ListWorkflowRunsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: status.v1.RunFilter filter = 3;
	 */
	filter?: RunFilterJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message status.v1.ListWorkflowRunsRequest.
 * Use `create(ListWorkflowRunsRequestSchema)` to create a new message.
 */
export const ListWorkflowRunsRequestSchema: GenMessage<ListWorkflowRunsRequest, { jsonType: ListWorkflowRunsRequestJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 9);

/**
 * @generated from message status.v1.ListWorkflowRunsResponse
 */
export type ListWorkflowRunsResponse = Message<"status.v1.ListWorkflowRunsResponse"> & {
	/**
	 * @generated from field: repeated status.v1.Run runs = 1;
	 */
	runs: Run[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message status.v1.ListWorkflowRunsResponse
 */
export type ListWorkflowRunsResponseJson = {
	/**
	 * @generated from field: repeated status.v1.Run runs = 1;
	 */
	runs?: RunJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message status.v1.ListWorkflowRunsResponse.
 * Use `create(ListWorkflowRunsResponseSchema)` to create a new message.
 */
export const ListWorkflowRunsResponseSchema: GenMessage<ListWorkflowRunsResponse, { jsonType: ListWorkflowRunsResponseJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 10);

/**
 * @generated from message status.v1.ListWorkflowStepsRequest
 */
export type ListWorkflowStepsRequest = Message<"status.v1.ListWorkflowStepsRequest"> & {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId: string;

	/**
	 * @generated from field: status.v1.StepFilter filter = 2;
	 */
	filter?: StepFilter;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message status.v1.ListWorkflowStepsRequest
 */
export type ListWorkflowStepsRequestJson = {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId?: string;

	/**
	 * @generated from field: status.v1.StepFilter filter = 2;
	 */
	filter?: StepFilterJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message status.v1.ListWorkflowStepsRequest.
 * Use `create(ListWorkflowStepsRequestSchema)` to create a new message.
 */
export const ListWorkflowStepsRequestSchema: GenMessage<ListWorkflowStepsRequest, { jsonType: ListWorkflowStepsRequestJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 11);

/**
 * @generated from message status.v1.ListWorkflowStepsResponse
 */
export type ListWorkflowStepsResponse = Message<"status.v1.ListWorkflowStepsResponse"> & {
	/**
	 * @generated from field: repeated status.v1.Step steps = 1;
	 */
	steps: Step[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message status.v1.ListWorkflowStepsResponse
 */
export type ListWorkflowStepsResponseJson = {
	/**
	 * @generated from field: repeated status.v1.Step steps = 1;
	 */
	steps?: StepJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message status.v1.ListWorkflowStepsResponse.
 * Use `create(ListWorkflowStepsResponseSchema)` to create a new message.
 */
export const ListWorkflowStepsResponseSchema: GenMessage<ListWorkflowStepsResponse, { jsonType: ListWorkflowStepsResponseJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 12);

/**
 * @generated from message status.v1.ExportWorkflowStepsRequest
 */
export type ExportWorkflowStepsRequest = Message<"status.v1.ExportWorkflowStepsRequest"> & {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId: string;

	/**
	 * @generated from field: status.v1.StepFilter filter = 2;
	 */
	filter?: StepFilter;
};

/**
 * @generated from message status.v1.ExportWorkflowStepsRequest
 */
export type ExportWorkflowStepsRequestJson = {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId?: string;

	/**
	 * @generated from field: status.v1.StepFilter filter = 2;
	 */
	filter?: StepFilterJson;
};

/**
 * Describes the message status.v1.ExportWorkflowStepsRequest.
 * Use `create(ExportWorkflowStepsRequestSchema)` to create a new message.
 */
export const ExportWorkflowStepsRequestSchema: GenMessage<ExportWorkflowStepsRequest, { jsonType: ExportWorkflowStepsRequestJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 13);

/**
 * @generated from message status.v1.ExportWorkflowStepsResponse
 */
export type ExportWorkflowStepsResponse = Message<"status.v1.ExportWorkflowStepsResponse"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;
};

/**
 * @generated from message status.v1.ExportWorkflowStepsResponse
 */
export type ExportWorkflowStepsResponseJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;
};

/**
 * Describes the message status.v1.ExportWorkflowStepsResponse.
 * Use `create(ExportWorkflowStepsResponseSchema)` to create a new message.
 */
export const ExportWorkflowStepsResponseSchema: GenMessage<ExportWorkflowStepsResponse, { jsonType: ExportWorkflowStepsResponseJson }> = /*@__PURE__*/ messageDesc(file_status_v1_status, 14);

/**
 * @generated from enum status.v1.StepStatus
 */
export enum StepStatus {
	/**
	 * @generated from enum value: STEP_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: STEP_STATUS_SUCCESS = 1;
	 */
	SUCCESS = 1,

	/**
	 * @generated from enum value: STEP_STATUS_FAILURE = 2;
	 */
	FAILURE = 2,
}

/**
 * @generated from enum status.v1.StepStatus
 */
export type StepStatusJson = "STEP_STATUS_UNSPECIFIED" | "STEP_STATUS_SUCCESS" | "STEP_STATUS_FAILURE";

/**
 * Describes the enum status.v1.StepStatus.
 */
export const StepStatusSchema: GenEnum<StepStatus, StepStatusJson> = /*@__PURE__*/ enumDesc(file_status_v1_status, 0);

/**
 * @generated from service status.v1.StatusService
 */
export const StatusService: GenService<{
	/**
	 * @generated from rpc status.v1.StatusService.ListWorkflowRuns
	 */
	listWorkflowRuns: {
		methodKind: "unary";
		input: typeof ListWorkflowRunsRequestSchema;
		output: typeof ListWorkflowRunsResponseSchema;
	};
	/**
	 * @generated from rpc status.v1.StatusService.ListWorkflowSteps
	 */
	listWorkflowSteps: {
		methodKind: "unary";
		input: typeof ListWorkflowStepsRequestSchema;
		output: typeof ListWorkflowStepsResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_status_v1_status, 0);
